import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { signUp } from "../slice/user/userSlice";
import PagePadding from "../layouts/PagePadding";
import Input from "../components/form-input/Input";
import InputPassword from "../components/form-input/InputPassword";
import Btn from "../components/btn/create-account/Btn";
import Outer from "../layouts/form/Outer";
import Inner from "../layouts/form/Inner";
import Footer from "../components/onboarding/Footer";
import { handleDisable } from "../utils/btn/handleDisable";
import { useNavigate } from "react-router-dom";
import req from "../axios/interceptedAxiosInstance";
import Verify from "./Verify";
import IsLoading from "../components/loading/IsLoading";
import { errorToast, successToast } from "../notification/notification";
import useAuth from "../hooks/useAuth";
import validator from "validator";

export const SignUp = ({ setLoading }) => {
  const dispatch = useDispatch();
  const { user } = useAuth();

  const [formIsSubmitted, setFormIsSubmitted] = useState(false);

  const [storeName, setStoreName] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const navigate = useNavigate();

  const reqBody = {
    user_name: storeName,
    email: email,
    first_name: firstName,
    last_name: lastName,
    phone_number: phoneNumber,
    password: password,
    is_terms_condition_checked: true,
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (
      // eslint-disable-next-line
      validator.isEmail(email) &&
      validator.matches(
        password,
        /([a-z].*[A-Z])|([A-Z].*[a-z])/ && /([!,%,&,@,#,$,^,*,?,_,~])/
      ) &&
      validator.isLength(password, { min: 8 }) &&
      validator.equals(password, confirmPassword)
    ) {
      setLoading(true);
      try {
        const response = await req.post("auth/register", reqBody);
        dispatch(signUp(response?.data?.data));
        successToast(response.data.message);
        setLoading(false);
        setFormIsSubmitted(true);
      } catch (error) {
        console.log(error);
        setLoading(false);
      }
    } else return errorToast("invalid email or password");
  };

  let disable = handleDisable([
    storeName,
    firstName,
    lastName,
    phoneNumber,
    email,
    password,
    confirmPassword,
  ]);

  useEffect(() => {
    if (user?.data) navigate("/communities");
  }, [navigate, user?.data]);

  if (formIsSubmitted) {
    return <Verify />;
  }

  return (
    <div className="relative">
      <PagePadding>
        <Outer>
          <Inner>
            <div className="mt-4 flex w-fit gap-14 items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-chevron-left cursor-pointer"
                viewBox="0 0 16 16"
                onClick={() => navigate(-1)}
              >
                <path
                  fillRule="evenodd"
                  d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
                />
              </svg>
              <h4 className="font-normal text-2xl">Let's get you started</h4>
            </div>

            <form className="mt-8">
              <Input
                type="text"
                placeholder="Store Name or Username"
                value={storeName}
                onValueChange={setStoreName}
                required={true}
                label="Store Name or Username"
              />
              <Input
                type="text"
                placeholder="First Name"
                value={firstName}
                onValueChange={setFirstName}
                required={true}
                label="First Name"
              />
              <Input
                type="text"
                placeholder="Last Name"
                value={lastName}
                onValueChange={setLastName}
                required={true}
                label="Last Name"
              />
              <Input
                type="tel"
                placeholder="Phone Number"
                min={11}
                value={phoneNumber}
                onValueChange={setPhoneNumber}
                required={true}
                label="Phone Number"
              />
              <Input
                type="email"
                placeholder="Email Address"
                value={email}
                onValueChange={setEmail}
                required={true}
                label="Email"
              />
              <div className="relative">
                <InputPassword
                  placeholder="Password"
                  password={password}
                  setPassword={setPassword}
                  label="Password"
                  min={8}
                  id="password"
                />
              </div>
              <div className="mt-">
                <InputPassword
                  placeholder="Confirm Password"
                  password={confirmPassword}
                  setPassword={setConfirmPassword}
                  match={password}
                  label="Confirm Password"
                />
              </div>
              <p className="mt-5 font-normal text-sm">
                by creating an account, you agree to the Thrifit's{" "}
                <span className="text-logoRed font-bold">Terms of Service</span>{" "}
                and{" "}
                <span className="text-logoRed font-bold">Privacy Policy</span>
              </p>
              <div>
                <Btn
                  innerText="Create Account"
                  inactive="bg-darkGrey"
                  active="bg-logoRed"
                  onclick={handleSubmit}
                  disable={disable}
                />
              </div>
            </form>
          </Inner>
        </Outer>
      </PagePadding>
      <Footer />
    </div>
  );
};

export default IsLoading(SignUp, "Signing you up");
